var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
var SvgContainersIcon = function (props) { return (_jsx("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: _jsx("path", { d: "m7 3.545-1.41 1.41L9 8.365l1.41-1.41L7 3.545Zm9.5 12.41H13v-5.59l5.41-5.41L17 3.545l-6 6v6.41H7.5l4.5 4.5 4.5-4.5Z", fill: "#fff" }) }))); };
var Memo = memo(SvgContainersIcon);
export default Memo;
//# sourceMappingURL=ContainersIcon.js.map